export const endPoints = {
  TABLE: '/v1/table',
  TABLE_KEY: (key?: string | null) => `/v1/table/${key}`,
  TABLE_ALL: '/v1/table/all'
};
